<template>
  <div v-bind="$attrs"
       v-on="$listeners"
       :style="style">
    <slot />
  </div>
</template>

<script>
  import { FontStyle } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TextEmailPrimary',
    inheritAttrs: false,
    props: {
      truncate: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        style: {
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.md,
          ...(this.truncate ? {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          } : {
            wordBreak: 'break-all',
          }),
        },
      };
    },
    created: function () {
      this.style = {
        ...this.style,
        color: this.color.dark2(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
